import log from 'lib/log'
import {
  loadGroupPosts,
  loadPublishedPostById,
  loadReferencesForGroup
} from 'actions/posts'
import { loadGroupActivities } from 'actions/activity'
import { isFollowingTags } from 'actions/follow'
import { loadResponses } from 'actions/responses'
import { loadSubGroups } from 'actions/groups'

const loadPosts = async (groupId, dispatch, getState, opts) => {
  try {
    await loadGroupPosts({
      group: groupId
    })(dispatch, getState, opts)
  } catch (err) {
    log.error(err)
  }
}

const loadActivity = async (groupId, dispatch, getState, opts) => {
  try {
    await loadGroupActivities({
      group: groupId
    })(dispatch, getState, opts)
  } catch (err) {
    log.error(err)
  }
}

const loadOutcome = async ({ outcome }, profile, dispatch, getState, opts) => {
  // start loading conversations about the post as soon as possible, as
  // this may well be the bit we have to wait longest for ...
  const post = await loadPublishedPostById({ _id: outcome })(
    dispatch,
    getState,
    opts
  )
  if (post) {
    try {
      await loadResponses({ _id: post._id })(dispatch, getState, opts)
    } catch (responsesErr) {
      log.error(responsesErr)
    }
    if (profile) {
      try {
        const tags = await isFollowingTags({
          entities: post.tags,
          followerId: profile._id
        })(dispatch, getState, opts)
      } catch (tagsErr) {
        log.error(tagsErr)
      }
    }
  }
}

const loadReferences = async (groupId, dispatch, getState, opts) => {
  return await loadReferencesForGroup({ group: groupId })(
    dispatch,
    getState,
    opts
  )
}

const loadGroups = async (groupId, dispatch, getState, opts) => {
  return await loadSubGroups({ group: groupId })(dispatch, getState, opts)
}

const isAllowedToViewContent = (group, membership) => {
  return group.privacy !== 'PRIVATE' || membership
}

const prepareTertiaryContent = async (
  { group, membership },
  profile,
  place,
  dispatch,
  getState,
  opts
) => {
  switch (place) {
    case 'groups/group/outcome':
      if (isAllowedToViewContent(group, membership)) {
        await loadOutcome(group, profile, dispatch, getState, opts)
      }
      break
    case 'groups/group/activity':
      if (isAllowedToViewContent(group, membership)) {
        await loadActivity(group._id, dispatch, getState, opts)
      }
      break
    case 'groups/group/events':      
    case 'groups/group/posts':
      if (isAllowedToViewContent(group, membership)) {
        await loadPosts(group._id, dispatch, getState, opts)
      }
      break
    case 'groups/group/reference':
      await loadReferences(group._id, dispatch, getState, opts)
      break
    case 'groups/group/groups':
      if (isAllowedToViewContent(group, membership)) {
        await loadGroups(group._id, dispatch, getState, opts)
      }
      break
    default:
      log.error('todo: load tertiary content for ' + place)
  }
}

export default prepareTertiaryContent
